import { DOCUMENT } from '@angular/common';
import { Component, HostListener, effect, inject, input } from '@angular/core';
import { FormDataService } from '@shared/core/services/form-data.service';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  @HostListener('click', ['$event'])
  onOverlayClick(event: Event) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('popup-overlay')) {
      this.close();
    }
  }

  public removeInlinePadding = input<boolean>(false);

  public formS = inject(FormDataService);

  private document = inject(DOCUMENT);

  private body = this.document.body;

  constructor() {
    effect(() => {
      if (!this.formS.currentStep()) {
        this.body.classList.remove('modalOpen');
      } else {
        this.body.classList.add('modalOpen');
      }
    });
  }

  close() {
    this.formS.updateCurrentStep(null);
    this.body.classList.remove('modalOpen');
  }
}
